import { PropertyOwnerPermissionType } from 'models/Owner';
import FormWithProvider from 'components/forms/form/Form';
import { Modal } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';
import useAppModal from 'hooks/useAppModal';
import CheckboxField from 'components/forms/checkboxField/CheckboxField';
import { TableItemOwner } from '../../PropertySettingsOwnersTab.types';
import OwnerPermissionsModalFooter from './OwnerPermissionsModalFooter';
import {
  formSchema,
  OwnerPermissionsFormSchemaType,
} from './OwnerPermissionsModal.schema';
import { ModalContainer } from './OwnerPermissionsModal.styles';

export const ownerPermissionsModalId = 'owner-permissions-modal';

const OwnerPermissionsModal = ({
  owner,
  onSubmit,
}: {
  owner: TableItemOwner;
  onSubmit: (values: OwnerPermissionsFormSchemaType) => void;
}) => {
  const { t } = useTranslation();
  const { closeModal } = useAppModal();

  const handleClose = () => {
    closeModal(ownerPermissionsModalId);
  };

  const getDefaultValues = () => {
    const checkPermission = (permission: PropertyOwnerPermissionType) => {
      return owner?.permissionTypes?.includes(permission);
    };

    return {
      uid: owner?.uid,
      [PropertyOwnerPermissionType.READING_CALENDAR]: checkPermission(
        PropertyOwnerPermissionType.READING_CALENDAR,
      ),
      [PropertyOwnerPermissionType.READING_BOOKING_DETAILS]: checkPermission(
        PropertyOwnerPermissionType.READING_BOOKING_DETAILS,
      ),
      [PropertyOwnerPermissionType.READING_BOOKING_VALUE]: checkPermission(
        PropertyOwnerPermissionType.READING_BOOKING_VALUE,
      ),
      [PropertyOwnerPermissionType.CREATING_BLOCKS]: checkPermission(
        PropertyOwnerPermissionType.CREATING_BLOCKS,
      ),
    };
  };

  return (
    <FormWithProvider
      horizontal
      onSubmit={onSubmit}
      defaultValues={getDefaultValues()}
      resolver={formSchema}
    >
      <ModalContainer>
        <Modal.Header closeButton>
          <Modal.Title>
            <Trans
              i18nKey="pageProperty.owners.permissionsModal.title"
              values={{ ownerName: owner?.fullName }}
              components={{ 1: <span className="green" /> }}
            />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{t('pageProperty.owners.permissionsModal.description')}</p>

          <CheckboxField name={PropertyOwnerPermissionType.READING_CALENDAR}>
            {t('pageProperty.owners.permissionsModal.options.READING_CALENDAR')}
          </CheckboxField>

          <CheckboxField
            name={PropertyOwnerPermissionType.READING_BOOKING_DETAILS}
          >
            {t(
              'pageProperty.owners.permissionsModal.options.READING_BOOKING_DETAILS',
            )}
          </CheckboxField>

          <CheckboxField
            name={PropertyOwnerPermissionType.READING_BOOKING_VALUE}
            className="subCheckbox"
          >
            {t(
              'pageProperty.owners.permissionsModal.options.READING_BOOKING_VALUE',
            )}
          </CheckboxField>

          <CheckboxField name={PropertyOwnerPermissionType.CREATING_BLOCKS}>
            {t('pageProperty.owners.permissionsModal.options.CREATING_BLOCKS')}
          </CheckboxField>
        </Modal.Body>

        <OwnerPermissionsModalFooter onClose={handleClose} />
      </ModalContainer>
    </FormWithProvider>
  );
};

export default OwnerPermissionsModal;
